import React from "react";
import Header from "./dashboard/Header";
import Menu from "./dashboard/Menu";
import Metadata from "./Metadata.js";

export default function DashboardLayout({ children, title, description }) {
  return (
    <div className="wrapper wrapper--light">
      <Metadata title={title} description={description} />
      <Header />
      <div className="grid grid--dashboard">
        <Menu />
        <div className="container container--dashboard">
          {children}
        </div>
      </div>
    </div>
  );
}
